(() => {
  if (customElements.get('q4-product-carousel')) return;
  customElements.define('q4-product-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.q4-picks__track');
      this.previous = this.querySelector('[data-q4-prev]');
      this.next = this.querySelector('[data-q4-next]');
      if (!this.track || !this.previous || !this.next) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.update = () => {
        this.previous.disabled = this.track.scrollLeft < 3;
        this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 3;
      };
      const move = direction => {
        const card = this.track.firstElementChild;
        if (!card) return;
        // Match the collection carousels: move one card with native smooth scrolling.
        const gap = parseFloat(getComputedStyle(this.track).columnGap);
        const stride = card.offsetWidth + (Number.isFinite(gap) ? gap : 0);
        this.track.scrollBy({ left: direction * stride, behavior: 'smooth' });
      };
      this.previous.addEventListener('click', () => move(-1), options);
      this.next.addEventListener('click', () => move(1), options);
      this.track.addEventListener('scroll', this.update, { ...options, passive: true });
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this.track);
      this.querySelector('.q4-picks__controls').hidden = false;
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
  });
})();
